'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:CustomersCtrl
 * @description
 * # CustomersCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('CustomersCtrl',
    function($window, $location, $uibModal, $controller, $routeParams,
      CustomerService, AuthenticationService, FlashService, modalService, appSettings) {

      var customersVm = this;
      var redirectToImport = $location.search().redirectToImport;
      $controller('BaseController', {vm : customersVm});

      customersVm.select = selectCustomer;
      customersVm.edit = editCustomer;
      customersVm.remove = deleteCustomer;
      customersVm.clearSelection = clearCustomerSelection;
      customersVm.search = search;
      customersVm.customerList = [];
      customersVm.selected = [];
      customersVm.modalOptions = {};
      customersVm.inprogress = false;
      customersVm.hasSelection = false;
      customersVm.searchCriteria = !!$routeParams.q ? $routeParams.q : undefined;
      customersVm.showSearch = showSearch;
      customersVm.import = importCustomers;


      customersVm.baseActivate(activate);

      return customersVm;

      function activate() {
        if (!!redirectToImport && +redirectToImport) {
          return importCustomers();
        }

        return customersVm.requestStart()
          .then(getCustomers)
          .catch(customersVm.requestFailure.bind(customersVm));
      }

      function getCustomers() {
        return CustomerService.GetAll()
          .then(getCustomersSuccess)
          .catch(getCustomersFailed)
          .then(customersVm.requestComplete.bind(customersVm));
      }

      function getCustomersSuccess(response) {
        customersVm.customerList = setActiveCustomers(response);
      }

      function getCustomersFailed(error) {
        return customersVm.requestFailure(error);
      }

      function setActiveCustomers(customerList) {
        angular.forEach(customerList, function(customer) {
          customer.status = customer.deleted === true ? 'Inactive' : 'Active';
        });

        return customerList;
      }

      function selectCustomer(customer) {
        if (customer.selected === true) {
          var removeIndex = customersVm.selected.indexOf(customer.id);
          customersVm.selected.splice(removeIndex, 1);
        } else {
          customersVm.selected.push(customer.id);
        }

        customer.selected = !customer.selected;
        customersVm.hasSelection = customersVm.selected.length > 0;
      }

      function search() {
        var criteria = customersVm.searchCriteria;
        if (!criteria || !(criteria.trim())) {
          return;
        }

        $window.history.pushState(null, $window.title, 'customers?q='+ criteria);
        customersVm.searchCriteria = criteria;
      }

      function clearCustomerSelection() {
        angular.forEach(customersVm.customerList, function(value) {
          value.selected = false;
        });

        customersVm.selected = [];
        customersVm.hasSelection = customersVm.selected.length > 0;
      }

      function editCustomer(customer) {
        $location.path('/customers/' + customer.id + '/update');
      }

      function deleteCustomer(customer) {
        var fullName = customer.firstName + ' ' + customer.lastName;
        customersVm.modalOptions = setupModalOptions(fullName);

        modalService.showModal({}, customersVm.modalOptions)
          .then(deleteCustomerRequest.bind(null, customer));
      }

      function importCustomers() {
        var authData = AuthenticationService.getAuthData();
        // var length = appSettings.api.baseUrl.length;
        $window.location.href = appSettings.api.baseUrl + 'Home/Login?token=' + authData.token;
      }

      function showSearch() {
        return !customersVm.inprogress && !!customersVm.searchCriteria;
      }

      function setupModalOptions(fullName) {
        return {
          closeButtonText: 'Cancel',
          actionButtonText: 'Delete Customer',
          headerText: 'Delete ' + fullName + '?',
          bodyText: 'Are you sure you want to delete this customer?'
        };
      }

      function deleteCustomerRequest(customer) {
        customersVm.inprogress = true;
        customersVm.requestStart();

        CustomerService.Delete(customer.id)
          .then(deleteCustomerSuccess.bind(null, customer))
          .catch(deleteCustomerFailure)
          .then(deleteCustomerComplete);
      }

      function deleteCustomerSuccess(customer) {
        var index = customersVm.customerList.indexOf(customer);
        customersVm.customerList.splice(index, 1);
        FlashService.Success(customer.firstName + ' ' + customer.lastName + ' has been deleted', false);
      }

      function deleteCustomerFailure(error) {
        customersVm.requestFailure(error);
        return FlashService.Error('Could not delete customer', false);
      }

      function deleteCustomerComplete() {
        customersVm.requestComplete();
        customersVm.inprogress = false;
      }
    });
